export default {
  "content": "<path d=\"M10.724 7.431L6.236 11.92a2.625 2.625 0 01-3.712-3.713l6.381-6.38A1.75 1.75 0 1111.38 4.3l-6.387 6.387M5 10.68l-.006.006m3.324-5.8L3.761 9.445a.875.875 0 001.232 1.242\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "14",
    "viewBox": "0 0 14 14",
    "fill": "none"
  }
};